<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>{{ id ? "编辑活动" : "新增活动" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content" style="padding-top: 15px">
      <el-form
        ref="activityForm"
        :model="activityForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="活动商品：">
          <el-button @click="dialogGoodsSel = true" v-if="!confirmList.goodsImage"
            >选择商品</el-button
          >
          <img
            v-else
            :src="confirmList.goodsImage"
            alt=""
            style="width: 80px; height: 80px"
          />
        </el-form-item>
        <el-form-item label="活动规格：">
          <div>
            <div class="specification-header flex-row-between">
              <div class="width25" v-for="item in specificationList" :key="item.id">
                {{ item.name }}
              </div>
            </div>
            <div class="specification-body flex-row-between">
              <div class="width25">{{ confirmList.goodsName }}</div>
              <div class="width25">{{ confirmList.unit }}</div>
              <div class="width25">{{ confirmList.retailPrice }}</div>
              <div class="width25">{{ confirmList.totalStockCount }}</div>
              <div
                class="width25"
                v-show="confirmList.retailPrice"
                @click="deleteGoods"
                v-if="!id"
              >
                删除
              </div>
              <div class="width25" v-else></div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="活动名称：" prop="activityName">
          <el-input
            v-model="activityForm.activityName"
            placeholder="请输入活动名称"
            :maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品底价：" prop="price">
          <el-input
            v-model="activityForm.price"
            :disabled="id ? true : false"
            type="number"
            @blur="priceBlur"
            placeholder="请输入团购价格"
          ></el-input>
        </el-form-item>
        <el-form-item label="砍价模式" prop="pattern">
          <el-radio-group v-model="activityForm.pattern">
            <el-radio :label="1">砍到底价才可购买</el-radio>
            <el-radio :label="2">无需砍到底价即可购买</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="需砍次数：" prop="targetCount">
          <span>
            预计需要<el-input
              v-model="activityForm.targetCount"
              style="width: 110px"
              type="number"
              placeholder="需砍次数"
              @blur="targetCountBlur"
            ></el-input
            >个好友帮砍后才能砍到底价
          </span>
        </el-form-item>
        <el-form-item label="活动时间：" prop="time">
          <el-date-picker
            v-model="activityForm.time"
            @change="timeChange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="expireTimeOption"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog class="dialog-selgoods" title="选择商品" :visible.sync="dialogGoodsSel">
      <div class="content-page">
        <div class="bd">
          <div class="tab-header">
            <div class="header-right">
              <el-input
                placeholder="请输入商品..."
                v-model.trim="searchInput"
                class="input-search"
                size="small"
                @keyup.enter.native="searchGoods"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchGoods"
                ></el-button>
              </el-input>
            </div>
          </div>
          <div class="tab-content">
            <div class="goods-classify-wrap">
              <ol class="goods-classify-list">
                <li
                  v-for="item in classifyOptions"
                  :key="item.goodsCategoryId"
                  :class="isPrimaryCategoryActive(item) ? 'active' : ''"
                  @click="menuSelAction(item)"
                >
                  {{ item.categoryName }}
                </li>
              </ol>
              <ol
                class="goods-classify-list secondary"
                v-if="showSecondaryCategoryPanel"
                v-loading="secondaryCategoryLoading"
              >
                <li
                  v-for="item in secondaryClassifyOptions"
                  :key="item.goodsCategoryId"
                  :class="goodsCategoryId == item.goodsCategoryId ? 'active' : ''"
                  @click="secondaryMenuSelAction(item)"
                >
                  {{ item.categoryName }}
                </li>
              </ol>
            </div>
            <div class="goods-list">
              <div class="list-title">
                <div class="title">商品</div>
                <div class="title">规格</div>
              </div>
              <el-checkbox-group v-model="checkedGoodsList" @change="checkedGoodsChange">
                <el-table :data="goodsList" style="width: 100%" :show-header="false">
                  <el-table-column width="400">
                    <template slot-scope="scope">
                      <el-checkbox
                        :label="scope.row.goodsId"
                        @click="selGoodsProducts(scope.row.products, scope.$index)"
                      >
                        <div class="goods-info">
                          <el-image
                            class="pic"
                            :src="scope.row.goodsImage || defaultImg"
                            fit="fill"
                            :class="{
                              'lower-shelf': !scope.row.saleStatus,
                              'will-sell-out':
                                scope.row.totalStockCount > 1 &&
                                scope.row.totalStockCount <= 10 &&
                                scope.row.saleStatus,
                              'sell-out':
                                scope.row.totalStockCount <= 0 && scope.row.saleStatus,
                            }"
                          ></el-image>
                          <div class="info">
                            <div class="title">
                              {{ scope.row.goodsName }}
                              <div class="tag-list">
                                <span v-if="scope.row.unitType == 2">计重</span>
                              </div>
                            </div>
                            <p class="price">￥{{ scope.row.retailPrice }}</p>
                          </div>
                        </div>
                      </el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot-scope="scope">
                      <p v-if="scope.row.products.length > 0">
                        已选规格： {{ scope.row.checkedValueContent }}
                      </p>
                      <el-link
                        v-if="scope.row.products.length > 0"
                        type="primary"
                        :underline="false"
                        @click="selGoods(scope.row)"
                        >选择</el-link
                      >
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-checkbox-group>
              <div class="list-footer">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :page-size="queryInfo.row"
                  :current-page="queryInfo.pageNo"
                  background
                  layout="total, prev, pager, next"
                  :total="total"
                ></el-pagination>
                <el-button type="primary" size="medium" @click="confirmAdd"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        class="dialog-selproducts"
        width="600px"
        title="选择规格"
        :visible.sync="dialogGoodsSpecification"
        append-to-body
      >
        <div class="content-page">
          <div class="tab-content">
            <div class="products-list">
              <div class="list-title">
                <div class="title">规格</div>
                <div class="title">价格</div>
              </div>
              <el-checkbox-group
                v-model="checkProductsList"
                @change="checkProductsChange"
              >
                <el-table :data="productsList" style="width: 100%" :show-header="false">
                  <el-table-column>
                    <template slot-scope="scope">
                      <el-checkbox :label="scope.row.productId">
                        <div class="goods-info">
                          <div class="info">
                            <div class="title">
                              {{ scope.row.valueContent }}
                            </div>
                          </div>
                        </div>
                      </el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot-scope="scope">
                      {{ scope.row.retailPrice }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-checkbox-group>
              <div class="list-footer">
                <div style="margin-top: 15px">
                  <el-button type="primary" @click="selProductsConfirm">确定</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import {
  addOrUpdateActivity,
  getSingleActivityList,
  getEdcShopGoodsCategorys,
  getFindAllGoodsPlus,
  findGoodsNum,
} from "../api/index";
import { formatGoodsCategoryListForUI } from "@/utils/goodsCategory";
import {
  isSecondaryCategorySwitchOn,
  getSecondaryCategoryList,
} from "@/utils/secondaryCategory";
export default {
  data() {
    return {
      id: "",
      activityForm: {
        activityName: "",
        price: "",
        targetCount: "",
        time: "",
        startTime: "",
        endTime: "",
        pattern: "",
      },
      rules: {
        activityName: [{ required: true, message: "请输入团购标题", trigger: "blur" }],
        price: [{ required: true, message: "请输入团购价格", trigger: "blur" }],
        targetCount: [{ required: true, message: "请输入成团人数", trigger: "blur" }],
        time: [{ required: true, message: "请选择日期", trigger: "change" }],
        pattern: [{ required: true, message: "请选择砍价模式", trigger: "change" }],
      },
      dialogGoodsSel: false,
      searchInput: "",
      defaultImg: require("../assets/img/common/default-img.jpg"),
      classifyOptions: [],
      classifyOptionsLv1: [],
      secondaryClassifyOptions: [],
      secondaryCategoryCache: {},
      secondaryCategoryPendingMap: {},
      secondaryCategoryLoading: false,
      secondaryCategoryRequestKey: 0,
      activePrimaryCategoryId: "",
      goodsList: [],
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      status: "",
      goodsCategoryId: "",
      checkedGoodsList: [],
      checkArr: [],
      dialogGoodsSpecification: false,
      checkProductsList: [],
      productsList: [],
      specificationList: [
        { name: "商品名称", id: 1 },
        { name: "商品单位", id: 2 },
        { name: "商品价格", id: 3 },
        { name: "库存", id: 4 },
        { name: "操作", id: 5 },
      ],
      checkedList: [],
      confirmList: {},
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
    };
  },
  computed: {
    showSecondaryCategoryPanel() {
      return this.secondaryCategoryLoading || this.secondaryClassifyOptions.length > 0;
    },
  },
  beforeDestroy() {
    localStorage.removeItem("updateActivityId");
  },
  mounted() {
    this.id = localStorage.updateActivityId;
    console.log(this.id, "id");
    this.getSingleActivityList(this.id);
    this.getEdcShopGoodsCategorys();
  },
  methods: {
    initSecondaryCategoryCache(categoryList = []) {
      const cache = Object.assign({}, this.secondaryCategoryCache);
      const nextCache = {};
      (categoryList || []).forEach((item) => {
        if (Number(item.level) !== 2 || !item.parentId) {
          return;
        }
        const parentId = `${item.parentId}`;
        if (!nextCache[parentId]) {
          nextCache[parentId] = [];
        }
        nextCache[parentId].push({
          ...item,
          rawCategoryName: item.rawCategoryName || item.categoryName,
        });
      });
      Object.keys(nextCache).forEach((parentId) => {
        cache[parentId] = nextCache[parentId];
      });
      this.secondaryCategoryCache = cache;
    },
    resetSecondaryCategoryPanel() {
      this.secondaryCategoryRequestKey += 1;
      this.secondaryCategoryLoading = false;
      this.secondaryClassifyOptions = [];
    },
    applySecondaryCategoryPanel(list = []) {
      this.secondaryCategoryLoading = false;
      this.secondaryClassifyOptions = Array.isArray(list) ? list.slice() : [];
    },
    async fetchSecondaryCategoryList(parentItem, options = {}) {
      const { showInPanel = false } = options;
      if (!parentItem || !parentItem.goodsCategoryId || !isSecondaryCategorySwitchOn()) {
        if (showInPanel) {
          this.resetSecondaryCategoryPanel();
        }
        return [];
      }
      const parentId = `${parentItem.goodsCategoryId}`;
      if (Object.prototype.hasOwnProperty.call(this.secondaryCategoryCache, parentId)) {
        const cachedList = this.secondaryCategoryCache[parentId] || [];
        if (showInPanel) {
          this.applySecondaryCategoryPanel(cachedList);
        }
        return cachedList;
      }
      let requestKey = this.secondaryCategoryRequestKey;
      if (showInPanel) {
        requestKey = this.secondaryCategoryRequestKey + 1;
        this.secondaryCategoryRequestKey = requestKey;
        this.secondaryCategoryLoading = true;
        this.secondaryClassifyOptions = [];
      }
      if (!this.secondaryCategoryPendingMap[parentId]) {
        this.secondaryCategoryPendingMap[parentId] = getSecondaryCategoryList(
          parentItem.goodsCategoryId,
          100
        )
          .then((res) => {
            const nextList =
              res.code == 1 && Array.isArray(res.data)
                ? res.data.map((item) => {
                    return {
                      ...item,
                      parentId: item.parentId || parentItem.goodsCategoryId,
                      rawCategoryName: item.rawCategoryName || item.categoryName,
                    };
                  })
                : [];
            this.$set(this.secondaryCategoryCache, parentId, nextList);
            return nextList;
          })
          .finally(() => {
            delete this.secondaryCategoryPendingMap[parentId];
          });
      }
      const nextList = await this.secondaryCategoryPendingMap[parentId];
      if (showInPanel && requestKey === this.secondaryCategoryRequestKey) {
        this.applySecondaryCategoryPanel(nextList);
      }
      return nextList;
    },
    syncCategorySelection(goodsCategoryId, options = {}) {
      const { primaryId = "", keepSecondaryPanel = false } = options;
      if (!keepSecondaryPanel) {
        this.resetSecondaryCategoryPanel();
      }
      this.goodsCategoryId = goodsCategoryId;
      this.activePrimaryCategoryId = primaryId;
      this.getFindAllGoodsPlus(this.goodsCategoryId);
    },
    isPrimaryCategoryActive(item) {
      if (!item) {
        return false;
      }
      if (!item.goodsCategoryId) {
        return !this.goodsCategoryId;
      }
      return `${item.goodsCategoryId}` == `${this.activePrimaryCategoryId}`;
    },
    getSingleActivityList(activityId) {
      getSingleActivityList({
        activityId: activityId,
      }).then((res) => {
        if (res.code == 1) {
          this.activityForm = res.data;
          this.$set(this.activityForm, "time", [res.data.startTime, res.data.endTime]);
          this.confirmList = {
            goodsName: res.data.goodsName,
            goodsImage: res.data.goodsImage,
            valueContent: res.data.valueContent,
            retailPrice: res.data.retailPrice,
            goodsId: res.data.goodsId,
            productId: res.data.productId,
            unit: res.data.unit,
            totalStockCount: res.data.totalStockCount,
          };
        } else {
        }
      });
    },
    timeChange(val) {
      if (val) {
        console.log(val);
        this.activityForm.startTime = val[0];
        this.activityForm.endTime = val[1];
      }
    },
    priceBlur(e) {
      let value = e.target.value;
      if (value != "") {
        if (value.indexOf(".") > -1) {
          this.activityForm.price = value.slice(0, value.indexOf(".") + 3);
        } else {
          this.activityForm.price = value.toFixed(2);
        }
      }
    },
    targetCountBlur(e) {
      let num = e.target.value;
      if (parseInt(num) == parseFloat(num)) {
        //如果相等，就是整数
        if (num < 1) {
          this.$notify({
            title: "提示",
            message: "成团人数需大于等于1",
            type: "warning",
            duration: 1000,
          });
          this.activityForm.targetCount = "";
          return;
        }
        this.activityForm.targetCount = num;
      } else {
        //否则就是小数
        this.activityForm.targetCount = "";
      }
    },
    submit() {
      console.log(this.activityForm);
      // return
      if (!this.confirmList.goodsId) {
        this.$notify({
          title: "提示",
          message: "请选择商品",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      this.$refs.activityForm.validate((valid) => {
        if (!valid) {
          this.$notify({
            title: "提示",
            message: "请输入相应信息",
            type: "warning",
            duration: 1000,
          });
          return;
        }
      });
      addOrUpdateActivity({
        activityId: this.id,
        goodsId: this.confirmList.goodsId,
        productId: this.confirmList.productId,
        activityType: 2,
        activityName: this.activityForm.activityName,
        price: this.activityForm.price,
        startTime: this.activityForm.startTime,
        endTime: this.activityForm.endTime,
        pattern: this.activityForm.pattern,
        targetCount: this.activityForm.targetCount,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: `${this.id ? "修改成功" : "新增成功"}`,
            type: "success",
            duration: 1000,
          });
          this.$router.push("/bargin");
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "warning",
            duration: 1000,
          });
        }
      });
    },
    // 分类下的商品
    menuSelAction(item) {
      if (!item) {
        return;
      }
      const id = item.goodsCategoryId;
      if (!id) {
        this.activePrimaryCategoryId = "";
        this.syncCategorySelection("");
        return;
      }
      const samePrimarySelected =
        `${this.goodsCategoryId}` == `${id}` &&
        `${this.activePrimaryCategoryId}` == `${id}`;
      if (
        samePrimarySelected &&
        (!isSecondaryCategorySwitchOn() ||
          Object.prototype.hasOwnProperty.call(this.secondaryCategoryCache, `${id}`))
      ) {
        return;
      }
      if (isSecondaryCategorySwitchOn()) {
        this.resetSecondaryCategoryPanel();
      }
      this.syncCategorySelection(id, {
        primaryId: id,
        keepSecondaryPanel: isSecondaryCategorySwitchOn(),
      });
      if (isSecondaryCategorySwitchOn() && Number(item.level) !== 2) {
        this.fetchSecondaryCategoryList(item, {
          showInPanel: true,
        });
        return;
      }
      this.activePrimaryCategoryId = item.parentId || "";
    },
    secondaryMenuSelAction(item) {
      if (!item || !item.goodsCategoryId) {
        return;
      }
      const parentId = item.parentId || this.activePrimaryCategoryId;
      if (
        `${this.goodsCategoryId}` == `${item.goodsCategoryId}` &&
        `${this.activePrimaryCategoryId}` == `${parentId}`
      ) {
        return;
      }
      this.syncCategorySelection(item.goodsCategoryId, {
        primaryId: parentId,
        keepSecondaryPanel: true,
      });
    },
    deleteGoods() {
      this.confirmList = {};
    },
    checkProductsChange(value) {
      console.log(value);
      let count = value.length;
      let newArr = [];
      if (count > 1) {
        value.splice(0, 1);
        // console.log(value, "选中的商品id")
        newArr = this.checkArr[0].products.filter((item) => {
          return item.productId == value[0];
        });
        // console.log(newArr, 123)
      } else {
        newArr = this.checkArr[0].products.filter((item) => {
          return item.productId == value[0];
        });
        // console.log(newArr, 456)
      }
      this.checkedList = newArr;
      // console.log(this.checkedList, "checkedList")
    },
    selProductsConfirm() {
      console.log(this.checkProductsList, "checkProductsList");
      // console.log(this.checkArr, "checkArr")
      // console.log(this.checkedList, "checkedList")
      this.dialogGoodsSpecification = false;
      if (this.checkProductsList.length <= 0) {
        this.goodsList.forEach((item) => {
          this.$set(item, "checkedValueContent", "");
        });
        return;
      }
      var index = this.goodsList.findIndex((item) => {
        return item.goodsId == this.checkedList[0].goodsId;
      });
      console.log(index);
      this.checkedGoodsList = [];
      if (index !== -1) {
        this.$set(
          this.goodsList[index],
          "checkedValueContent",
          this.checkedList[0].valueContent
        );
        this.checkedGoodsList.push(this.goodsList[index].goodsId);
      }
    },
    checkedGoodsChange(value) {
      // console.log(this.confirmList, "this.confirmList")
      if (this.confirmList.goodsId) {
        var index = this.goodsList.findIndex((item) => {
          return item.goodsId == this.confirmList.goodsId;
        });
        if (index !== -1) {
          this.$set(this.goodsList[index], "checkedValueContent", "");
          this.confirmList = {};
        }
      }
      // console.log(value, "选中的商品id")
      let checkedCount = value.length;
      let newArr = [];
      if (checkedCount > 1) {
        value.splice(0, 1);
        // console.log(value, "选中的商品id")
        newArr = this.goodsList.filter((item) => {
          return item.goodsId == value[0];
        });
        // console.log(newArr, 123)
      } else {
        newArr = this.goodsList.filter((item) => {
          return item.goodsId == value[0];
        });
        // console.log(newArr, 456)
      }
      this.checkArr = newArr;
      console.log(this.checkArr, 789);
      if (this.checkArr[0].products && this.checkArr[0].products.length >= 1) {
        this.productsList = this.checkArr[0].products;
        this.dialogGoodsSpecification = true;
      }
    },
    // 确定
    confirmAdd() {
      console.log(this.checkArr, "checkArr");
      console.log(this.checkedList, "checkedList");
      if (this.checkArr[0].products.length >= 1) {
        if (this.checkedList.length <= 0) {
          this.$notify({
            title: "提示",
            message: "请选择商品的规格",
            type: "warning",
            duration: 1000,
          });
          return;
        }
      }
      this.confirmList = {
        goodsName: this.checkArr[0].goodsName,
        goodsImage: this.checkArr[0].goodsImage,
        valueContent:
          this.checkedList.length >= 1
            ? this.checkedList[0].valueContent
            : this.checkArr[0].valueContent || "",
        retailPrice:
          this.checkedList.length >= 1
            ? this.checkedList[0].retailPrice
            : this.checkArr[0].retailPrice,
        goodsId:
          this.checkedList.length >= 1
            ? this.checkedList[0].goodsId
            : this.checkArr[0].goodsId,
        productId:
          this.checkedList.length >= 1
            ? this.checkedList[0].productId
            : this.checkArr[0].productId || "",
        unit: this.checkArr[0].unit || "",
        totalStockCount: this.checkArr[0].totalStockCount,
      };
      console.log(this.confirmList, "confirmList");
      this.dialogGoodsSel = false;
    },
    // 选择规格
    selGoods(item) {
      console.log(this.checkArr, "checkArr");
      console.log(item, "item");
      if (this.checkArr.length <= 0) {
        this.checkArr.push(item);
      }
      if (this.checkArr[0].goodsId == item.products[0].goodsId) {
        this.productsList = item.products;
        this.dialogGoodsSpecification = true;
      } else {
        this.$notify({
          title: "提示",
          message: "请选择对应的商品",
          type: "warning",
          duration: 1000,
        });
      }
    },
    selGoodsProducts(item, index) {
      console.log(item, index);
    },
    // 分类列表
    getEdcShopGoodsCategorys() {
      getEdcShopGoodsCategorys({
        pageNo: 1,
        row: 100,
      }).then((res) => {
        if (res.code == 1) {
          res.data = formatGoodsCategoryListForUI(res.data);
          this.initSecondaryCategoryCache(res.data);
          this.classifyOptionsLv1 = res.data.filter((item) => Number(item.level) !== 2);
          this.classifyOptions = [
            {
              categoryName: "全部",
              goodsCategoryId: "",
            },
            ...this.classifyOptionsLv1,
          ];
          this.resetSecondaryCategoryPanel();
          this.getFindAllGoodsPlus();
        } else {
          this.classifyOptions = [];
        }
      });
    },
    // 商品列表
    getFindAllGoodsPlus(goodsCategoryId) {
      getFindAllGoodsPlus({
        saleStatus: 1,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        goodsName: this.searchInput,
        goodsCategoryId: goodsCategoryId,
        goodsType: 1,
      }).then((res) => {
        findGoodsNum({
          saleStatus: 1,
          pageNo: this.queryInfo.pageNo,
          row: this.queryInfo.row,
          goodsName: this.searchInput,
          goodsCategoryId: goodsCategoryId,
          goodsType: 1,
        }).then((res) => {
          if (res.code == 1) {
            this.total = res.data;
          } else {
            this.total = 0;
          }
        });
        if (res.code == 1) {
          this.goodsList = res.data;
          this.goodsList.forEach((item) => {
            this.$set(item, "checkedValueContent", "");
          });
        } else {
          this.goodsList = [];
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      if (this.status == 1) {
        this.getFindAllGoodsPlus();
      } else {
        this.getFindAllGoodsPlus();
      }
    },
    searchGoods() {
      this.getFindAllGoodsPlus();
      this.status = 1;
    },
  },
};
</script>

<style lang="less" scoped>
.flex-row-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.specification-header {
  width: 452px;
  height: 40px;
  background: #f8f8f8;
  padding: 0 10px;
  color: #606266;
  font-size: 12px;
}
.specification-body {
  width: 450px;
  height: auto;
  border: 1px solid #ececec;
  border-top: none;
  padding: 0 10px;
  line-height: 40px;
}
.width25 {
  width: 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  box-sizing: border-box;
  &:last-child {
    cursor: pointer;
  }
}
.dialog-selproducts {
  .content-page {
    .tab-content {
      padding: 0;
      .products-list {
        width: 100%;
        .list-title {
          display: flex;
          padding: 0 20px 0 0;
          line-height: 40px;
          background: #f8f8f8;
          .title {
            box-sizing: border-box;
            padding-left: 10px;
            flex: 1;
          }
        }
        .list-footer {
          .el-button {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
.dialog-selgoods {
  .content-page {
    overflow: hidden;
    .bd {
      height: 100%;
      &.sort {
        height: 100%;
        overflow-y: scroll;
        .tab-header {
          background: #fffcf5;
          border-bottom-color: #f2e7b8;
        }
        .tab-content {
          .goods-list {
            width: 100%;
          }
        }
      }
    }
    .tab-header {
      .btn-group-one {
        .upload-xls {
          display: inline-block;
          margin: 0 15px;
        }
      }
      .btn-group-two {
        .el-checkbox {
          margin-right: 15px;
        }
      }
    }
    .tab-content {
      padding: 0;
      height: 500px;
      .goods-classify-wrap {
        display: flex;
        height: 100%;
        flex-shrink: 0;
      }
      .goods-classify-list {
        width: 120px;
        min-width: 120px;
        height: 100%;
        background: #f8f8f8;
        font-size: 12px;
        overflow: auto;
        li {
          color: #666666;
          padding-left: 20px;
          padding: 15px 20px;
          line-height: 20px;
          border-bottom: 1px solid #eeeeee;
          cursor: pointer;
          width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &.active {
            background: #fff;
          }
        }
      }
    }
    .tab-footer {
      text-align: center;
      margin: 10px 0;
      .el-button {
        margin-left: 10px;
      }
    }
    .el-pagination {
      padding: 0;
    }
    .goods-list {
      flex: 1;
      min-width: 0;
      box-sizing: border-box;
      .list-title {
        display: flex;
        padding: 0 20px 0 0;
        line-height: 40px;
        background: #f8f8f8;
        .title {
          box-sizing: border-box;
          padding-left: 10px;
          flex: 1;
          &:first-of-type {
            min-width: 400px;
            max-width: 400px;
            padding-left: 40px;
          }
        }
      }
      .el-checkbox-group {
        height: calc(100% - 96px);
        overflow: auto;
      }
      .search-header {
        line-height: 30px;
        margin: 10px 0;
        font-size: 14px;
        color: #333;
        padding-left: 10px;
        .el-link {
          vertical-align: top;
          line-height: 30px;
          margin-left: 20px;
        }
      }
      &.screen {
        width: 100%;
      }
      .list-footer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 15px 0 0 10px;
      }
      .goods-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        box-sizing: border-box;
      }
      .goods-info {
        display: flex;
        &.active {
          background: #f5f7fa;
        }
        .pic {
          position: relative;
          width: 50px;
          height: 50px;
          border-radius: 4px;
          &::before {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            text-align: center;
            line-height: 50px;
            font-size: 12px;
          }
          &.lower-shelf {
            &::before {
              content: "已下架";
            }
          }
          &.sell-out {
            &::before {
              content: "已售罄";
            }
          }
          &.will-sell-out {
            &::before {
              content: "将售罄";
            }
          }
        }
        .info {
          margin-left: 15px;
          .title {
            font-size: 14px;
            line-height: 28px;
            color: #666666;
            .tag-list {
              display: inline-block;
              & > span {
                background: #ee3030;
                color: #fff;
                font-size: 12px;
                border-radius: 3px;
                padding: 0 5px;
              }
            }
          }
          .price {
            font-size: 14px;
            line-height: 22px;
            color: #ee3030;
          }
        }
      }
      .table-action {
        & > span {
          margin: 0 10px;
        }
      }
      .list-none {
        text-align: center;
        font-size: 14px;
        color: #999999;
        padding-top: 200px;
        & > p {
          margin: 10px 0;
        }
      }
    }
  }
}
</style>
